import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/store';

export const selectProductSets = (state: RootState) => state.FurnitureAndEquipment.productSets;
export const selectBaseProductSets = (state: RootState) => state.FurnitureAndEquipment.baseProductSets;
export const selectProductSetCategories = (state: RootState) =>
  state.FurnitureAndEquipment.baseProductSets?.map(bps => bps.category);
export const selectProductCart = (state: RootState) => state.FurnitureAndEquipment.productCart;
export const selectProductRentalCartItems = (state: RootState) => state.FurnitureAndEquipment.productCart?.rental_items;
export const selectProductSetOrders = (state: RootState) => state.FurnitureAndEquipment.productSetOrders;
export const selectProductSetInventory = (state: RootState) => state.FurnitureAndEquipment.productSetInventory;
export const selectHasFurnitureAndEquipment = (state: RootState) => {
  const inventory = state.FurnitureAndEquipment.productSetInventory;
  return !!inventory && inventory.length > 0;
};
export const selectProductSetInventoryQuantity = (baseProductSetId: number) =>
  createSelector(selectProductSetInventory, inventory => {
    return (
      inventory
        ?.filter(item => item.product_set.base_product_set_id === baseProductSetId)
        .reduce((acc, item) => acc + item.rental_quantity + item.purchase_quantity, 0) || 0
    );
  });
export const selectDeliveredProductSetOrders = (state: RootState) => {
  const productSetOrders = selectProductSetOrders(state);
  return productSetOrders?.filter(order =>
    order.product_set_rental_groups.every(group => group.status === 'completed')
  );
};
export const selectNonDeliveredProductSetOrders = (state: RootState) => {
  const productSetOrders = selectProductSetOrders(state);
  return productSetOrders?.filter(order =>
    order.product_set_rental_groups.some(group => group.status === 'pending' || group.status === 'scheduled')
  );
};
export const selectSalesTaxRate = (state: RootState) => state.FurnitureAndEquipment.productCart?.sales_tax_rate;
export const selectTenancyServices = (state: RootState) => state.Tenancy.tenancy_services;
